export const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_URL;
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const GOOGLE_API_MASTER_URL = process.env.REACT_APP_GOOGLE_API_MASTER_URL;
export const STOREFRONT_API_KEY = process.env.REACT_APP_STOREFRONT_API_KEY;
export const STOREFRONT_API_URL = process.env.REACT_APP_STOREFRONT_API_URL;

export const billingPolicyIntervals = {
  DAY: '日ごと',
  WEEK: '週ごと',
  MONTH: 'ヶ月ごと',
  YEAR: '年ごと',
};

// 旧モデル、新モデルの切り替え日付
export const modelChangeDate = '2023/11/27';
